import React from 'react';
import ModalComponent from '../../../molecules/Modal';

/**
 * Render schedule order form in a popup modal Component
 * @param {*} props - Object
 */
export const ScheduleOrderInsideModal = props => {
  const { handleClose, ScheduleOrderForm, headerText, modalTitleId = '', handleGoBack } = props;
  return (
    <React.Fragment>
      <ModalComponent
        id='ScheduleOrderModal'
        role='dialog'
        ariaLabel='Close Start your Order dialog'
        modalTitleId={modalTitleId}
        show={true}
        classNames='search-store-modal extra-small-modal'
        showCloseBtn={true}
        closeButtonHandler={handleClose}
        modalTitle={headerText}
        closeDataTestId='close-modal-handler'
        showBackBtn={true}
        backButtonHandler={handleGoBack}
      >
        {ScheduleOrderForm}
      </ModalComponent>
    </React.Fragment>
  );
};

export default ScheduleOrderInsideModal;
